import { render, staticRenderFns } from "./appointmentDetails.vue?vue&type=template&id=5d9236c0&"
import script from "./appointmentDetails.vue?vue&type=script&lang=js&"
export * from "./appointmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9236c0')) {
      api.createRecord('5d9236c0', component.options)
    } else {
      api.reload('5d9236c0', component.options)
    }
    module.hot.accept("./appointmentDetails.vue?vue&type=template&id=5d9236c0&", function () {
      api.rerender('5d9236c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/appointmentDetails.vue"
export default component.exports